export const BFT_NUMBERS = [4, 7, 10, 13, 16, 19] as const;
